import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { ValidatorFn } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AbstractControl } from '@angular/forms';

import { AuthService } from 'src/app/service/auth/auth.service';
import { AlertService } from '../../../service/alert.service';
import { AnalyticsService } from 'src/app/service/analytics/analytics.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  public resetForm!: FormGroup<{ password: FormControl<string>; confirmedPassword: FormControl<string> }>;
  public currentYr = new Date().getFullYear();

  constructor(private authService: AuthService,
              private router: Router,
              private activeRoute: ActivatedRoute,
              private analytics: AnalyticsService,
              private alertService: AlertService) { }

  ngOnInit(): void {
    this.resetForm = new FormGroup({
      password: new FormControl("", { nonNullable: true, validators: [Validators.required] }),
      confirmedPassword: new FormControl("", { nonNullable: true, validators: [Validators.required, this.confirmEquals()] })}
      );
  }

  private confirmEquals(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>
        control.value?.toLowerCase() === this.passwordValue().toLowerCase()
            ? null : {noMatch: true};
  }

  private passwordValue(): string {
    let value = '';
    if (this.resetForm) {
      value = this.resetForm.get('password')?.value;
    }
    return value;
  }

  public onReset(): void {
    this.activeRoute
        .queryParams
        .subscribe(params => {

      let token = params['token'];

      this.authService
          .reset(token, this.resetForm.get('password')?.value)
          .subscribe(()=>{
            this.analytics.track('Password Reset Completed');
            this.alertService
                .success('Please login with your new password');
            this.router
                .navigateByUrl('/login');
          }, err => {
            console.error(err);
            this.alertService
                .error('Unable to reset password', err);
          }
      );
    });
  }

  public getFormControl(form: FormGroup, formControl: string): AbstractControl {
    let fControl: any;

    fControl = form.get(formControl)

    return fControl;
  }

}
